<template>
  <div>
    <div v-if="!actualRoom.selectedRoom">
      <!-- Загрузка -->
      <div v-if="actualRoom.isSearching" class="row q-col-gutter-lg">
        <div v-for="n in 6" :key="n" class="col-sm-12 col-md-6 col-lg-4">
          <q-card class="full-height" style="height: 100%">
            <q-skeleton height="200px" square />
            <q-card-section>
              <q-skeleton type="text" width="30%" class="text-h6" />
              <q-skeleton type="text" class="text-subtitle1" />
              <q-skeleton type="text" width="50%" class="text-subtitle1" />
              <q-skeleton type="text" width="80%" class="text-subtitle1" />
              <div class="row justify-between q-mt-sm">
                <q-skeleton type="text" width="30%" class="text-subtitle1" />
                <q-skeleton type="QBtn" width="150px" />
              </div>
            </q-card-section>
          </q-card>
        </div>
      </div>

      <!-- Ошибка запроса -->
      <div v-else-if="actualRoom.searchError" class="q-pa-md">
        <q-banner class="bg-negative text-white" rounded>
          <template #avatar>
            <q-icon name="error_outline" color="white" />
          </template>
          Не удалось загрузить номера. Проверьте подключение к интернету и попробуйте снова.
          <template #action>
            <q-btn flat color="white" label="Повторить поиск" @click="searchRooms" />
          </template>
        </q-banner>
      </div>

      <!-- Результаты поиска -->
      <template v-else-if="actualRoom.searchResult">
        <div v-if="hasAvailableRooms" class="q-mb-lg">
          <div v-if="hasVisibleOtherRooms" class="text-h6 q-mb-md">Доступные номера</div>
          <div class="row q-col-gutter-lg">
            <div v-for="room of availableRooms" :key="room.id" class="col-sm-12 col-md-6 col-lg-4">
              <room-card :room="room" roomType="available" />
            </div>
          </div>
        </div>

        <q-card v-if="!hasAvailableRooms" flat bordered class="q-mb-lg">
          <q-card-section>
            <q-banner class="bg-grey-2" rounded>
              <template #avatar>
                <q-icon name="hotel" color="grey-8" />
              </template>
              <div class="text-subtitle1 text-weight-medium q-mb-sm">
                Свободных номеров по выбранным параметрам не найдено
              </div>
              <div class="text-body2 text-grey-8 q-mb-sm">
                Попробуйте изменить даты заезда и выезда или состав гостей.
              </div>
              <div v-if="hasVisibleOtherRooms" class="text-body2 text-grey-8 q-mb-md">
                Ниже показаны ближайшие доступные варианты.
              </div>
              <q-btn color="primary" outline label="Изменить даты" @click="openDateSelector" />
            </q-banner>
          </q-card-section>
        </q-card>

        <div v-if="hasVisibleOtherRooms">
          <div class="text-h6 q-mb-md">Альтернативные даты и варианты размещения</div>
          <div class="row q-col-gutter-lg">
            <div
              v-for="room of visibleOtherRooms"
              :key="room.id"
              class="col-sm-12 col-md-6 col-lg-4"
            >
              <room-card :room="room" roomType="other" />
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { mapActions, mapState, mapWritableState } from 'pinia';

//stores
import { useSearchStore, TypeRoom } from '@/stores/searchStore';
import RoomCard from './RoomCard.vue';

export default defineComponent({
  components: { RoomCard },

  computed: {
    ...mapState(useSearchStore, ['actualRoom']),
    ...mapWritableState(useSearchStore, ['dateSelectorDialog']),

    availableRooms(): TypeRoom[] {
      return this.actualRoom.searchResult?.availableRoom ?? [];
    },

    hasAvailableRooms(): boolean {
      return this.availableRooms.length > 0;
    },

    visibleOtherRooms(): TypeRoom[] {
      const list = this.actualRoom.searchResult?.otherRoom ?? [];
      if (window.onlDefaults?.hideOtherRoomsWithoutAlternatives) {
        return list.filter((room) => room.otherSearch?.length);
      }
      return list;
    },

    hasVisibleOtherRooms(): boolean {
      return this.visibleOtherRooms.length > 0;
    },
  },
  methods: {
    ...mapActions(useSearchStore, ['searchRooms']),

    openDateSelector() {
      this.dateSelectorDialog = true;
    },
  },
  async created() {
    if (!this.actualRoom.selectedRoom) {
      await this.searchRooms();
    }
  },
});
</script>
